import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import { withTranslation } from 'react-i18next'
import withRouter from '../../../components/Common/withRouter'
import { useSelector, useDispatch } from "react-redux"
import * as Yup from "yup"
import Select from "react-select"
import { useFormik } from 'formik'
import { Link, useNavigate, useParams } from "react-router-dom"
import { createSelector } from "reselect"
import makeAnimated from "react-select/animated"
import {
  createTransfertOrder as onAddTransfertOrder,
  updateTransfertOrder as onUpdateTransfertOrder,
  confirmTransfertOrder as onConfirmTransfertOrder,
  getTransfertOrder as onGetTransfertOrder,
  getAllSuppliers as onGetAllSuppliers,
  getProductsAndSearchStock as onGetProductsAndSearchStock,
  deleteTransfertOrderItem as onDeleteTransfertOrderItem,
  loadUserByRole as getUserByRole
} from "../../../slice/thunks"
import { Button, Card, CardBody, Col, Input, Label, Modal, ModalBody, ModalFooter, Row } from 'reactstrap'
import TransfertRow from '../../../components/App/Warehouse/TransfertRow'
import DeleteModal from '../../../components/Global/DeleteModal'
import GlobalLoader from '../../../components/Common/GlobalLoader'


import logo from "../../../assets/images/HMS-Logo 1.png"
import PrintHeader from '../../../components/Global/PrintHeader'

const NewTransfertOrder = (props) => {
    const { id, action } = useParams()
    const [confirmModal, setConfirmModal] = useState(false)
    const dispatch = useDispatch()
    const history = useNavigate()
    const animatedComponents = makeAnimated()
    const selectLayoutState = (state) => state.Settings;
    const SettingsProperties = createSelector(
        selectLayoutState,
        (setting) =>({
            productsListStock: setting.productsListStock,
            transfertOrder: setting.transfertOrder,
            createTransfertOrderSuccess: setting.createTransfertOrderSuccess,
            updateTransfertOrderSuccess: setting.updateTransfertOrderSuccess,
            confirmTransfertOrderSuccess: setting.confirmTransfertOrderSuccess,
            deleteTransfertOrderSuccess: setting.deleteTransfertOrderSuccess,
            loadUserByRole: setting.loadUserByRole,
            error: setting.error
        })
    )
    const { productsListStock, transfertOrder, createTransfertOrderSuccess, updateTransfertOrderSuccess, confirmTransfertOrderSuccess, deleteTransfertOrderSuccess, loadUserByRole, error } = useSelector(SettingsProperties)
    const [productsOption, setProducstOption] = useState(null)
    const [selectedDestination, setSellectedDestination] = useState({ label: props.t("pharmacy"), value: "Pharmacy"})
    const [selectedProduct, setSellectedProduct] = useState(null)
    const [selectedDate, setSelectedDate] = useState(null)
    const [transferOrderItems, setTransfertOrderItems] = useState([])
    const [recievers, setRecievers] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isValidate, setIsValidate] = useState(false)
    const [isWatch, setIsWatch] = useState(false)
    const [isCreate, setIsCreate] = useState(false)
    const transfertTo = [
      { label: props.t("pharmacy"), value: "Pharmacy"},
      { label: props.t("laboratory"), value: "Laboratory"},
    ]
    const [isLoading, setIsLoading] = useState(true)
    const componentRef = useRef()

    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    })

    const loadAllSuppliers = useCallback(() => {
      dispatch(onGetAllSuppliers())
    })

    const loadSupplierOrder = useCallback((currentId) => {
      if (currentId) {
        dispatch(onGetTransfertOrder(currentId))
      }
    })

    const loadAllProduct = useCallback((term) => {
      if (term && term?.length > 0) {
        dispatch(onGetProductsAndSearchStock({term: term}))
      } else {
        dispatch(onGetProductsAndSearchStock())
      }
    })



    // component visibility Controller
    useEffect(() => {
       dispatch(getUserByRole())
      if (action && action === 'edit') {
        setIsEdit(true)
        setIsValidate(false)
        setIsWatch(false)
        setIsCreate(false)
      } else if (action && action === 'validate') {
        setIsValidate(true)
        setIsEdit(false)
        setIsWatch(false)
        setIsCreate(false)
      } else if (action && action === 'see') {
        setIsWatch(true)
        setIsEdit(false)
        setIsValidate(false)
        setIsCreate(false)
      }
     else if (!action) {
        setIsCreate(true)
        setIsEdit(false)
        setIsValidate(false)
        setIsWatch(false)
      }
    },[action])






    useEffect(() => {
      loadAllSuppliers();
      loadAllProduct();
      if ((action === 'edit') || action === 'validate' || action === 'see') {
        loadSupplierOrder(id)
      }
    },[dispatch])

    useEffect(() =>{
      setIsLoading(false)
      if (productsListStock && productsListStock?.length > 0) {
        const products_list = productsListStock.map( prod => {
          return {
            label: prod.product.name,
            value: prod.product.id,
            quantityInStock: prod.quantityInStock
          }
        })
        setProducstOption(products_list)
      } else {
        setProducstOption([]);
      }
    },[productsListStock])

    useEffect(() => {
      if (transfertOrder && transfertOrder.orderRef) {
        setSellectedDestination((transfertTo.filter((e) => e.value === transfertOrder.transferTo))[0])
        setSelectedDate(transfertOrder.orderDate)

        let Objproducts = transfertOrder.transferOrderItems.map(item => {
          return {
            id: item.id,
            productId: item.product.id,
            quantity: item.quantity,
            name: item.product.name,
            quantityInStock: item.product.quantity,
            unitPrice: item.product.sellingPrice,
            // quantityInRest: sup.quantityInStock,
          };
        });

        setTransfertOrderItems(Objproducts)
      }
    }, [transfertOrder])

    useEffect(() => {
      if (createTransfertOrderSuccess && !error) {
        setIsEdit(false)
        setSelectedDate(null)
        setSellectedDestination(null)
        setSellectedProduct(null)
        setTransfertOrderItems([])
        history("/warehouse/transfert-order")
      }
    },[createTransfertOrderSuccess, error, transfertOrder])

    useEffect(() => {
      if (updateTransfertOrderSuccess && !error) {
        history("/warehouse/transfert-order")
      }
    },[updateTransfertOrderSuccess, error, transfertOrder])

    useEffect(() => {
      if (confirmTransfertOrderSuccess && !error) {
        history("/warehouse/transfert-order")
      }
    },[confirmTransfertOrderSuccess, error, transfertOrder])

    useEffect(() => {
      if (deleteTransfertOrderSuccess && !error) {
        let current_products = [...transferOrderItems];
        current_products = current_products.filter((prod) => prod.productId !== selectedProduct.productId )
        setTransfertOrderItems(current_products);
      }
    },[deleteTransfertOrderSuccess, error, transfertOrder])

    useEffect(() => {
      if (selectedProduct !== null) {
          let current_products = [...transferOrderItems];
          if (!current_products.some((current) => current.productId === selectedProduct.productId)) {
            const new_products = [...current_products, selectedProduct];
            setTransfertOrderItems(new_products);
          }
      }
    }, [selectedProduct]);

    useEffect(() => {
      console.log("loadUserByRole",loadUserByRole);
      setRecievers(loadUserByRole)

    }, [loadUserByRole]);


    const handleSelectDestination = (sup) => {
      setSellectedDestination(sup)
    }

    const handleSelectProduct = (sup) => {
      if(sup) {
        let row = {
          productId: sup.value,
          name: sup.label,
          quantityInStock: sup.quantityInStock,
          quantityInRest: sup.quantityInStock,
          quantity: 1
        }
        setSellectedProduct(row)
      }
    }

    const handleSearchProduct = (value) => {
      loadAllProduct(value)
    }

    const handleUpdateRow = (row) => {
      let current_products = [...transferOrderItems];
      const index = current_products.findIndex(objet => objet.productId === row.productId);
      if (index !== -1) {
        current_products[index] = { ...current_products[index], ...row };
        setTransfertOrderItems(current_products);
      }

    }

    const handleChangeDate = (val) => {
      setSelectedDate(val)
    }

    const getTodayDate = () => {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    const onClickDelete = (row) => {
      setSellectedProduct(row)
      setDeleteModal(true);
    }

    const handleDelete = () => {
      console.log("selectedProduct",selectedProduct);

      if (selectedProduct) {
        if (selectedProduct.id) {
          dispatch(onDeleteTransfertOrderItem(selectedProduct))
        } else {
          let current_products = [...transferOrderItems];
          current_products = current_products.filter((prod) => prod.productId !== selectedProduct.productId )
          setTransfertOrderItems(current_products);
        }
        setDeleteModal(false)
      }
    }

    const saveOrder = () => {
      let productsOrder = []

      if (isValidate) {
        setConfirmModal(true)

        // productsOrder =  transferOrderItems.map(item => {
        //   return {
        //     id: item.id,
        //     productId: item.productId,
        //     quantity: item.quantity,
        //   };
        // });

        // let confirmData = {
        //   orderDate: selectedDate,
        //   transferTo: selectedDestination.value || "Pharmacy",
        //   status: "",
        //   transferOrderItems: productsOrder
        // }


      }else if (isEdit) {
        productsOrder =  transferOrderItems.map(item => {
          return {
            id: item.id,
            productId: item.productId,
            quantity: item.quantity
          };
        });

        let updateData = {
          orderDate: selectedDate,
          transferTo: selectedDestination.value || "Pharmacy",
          status: "",
          transferOrderItems: productsOrder
        }
        dispatch(onUpdateTransfertOrder({ id:id, data:updateData }))
      } else {

        productsOrder =  transferOrderItems.map(item => {
          return {
            productId: item.productId,
            quantity: item.quantity
          };
        });

        let createData = {
          orderDate: selectedDate,
          transferTo: selectedDestination.value || "Pharmacy",
          status: "",
          transferOrderItems: productsOrder
        }

        dispatch(onAddTransfertOrder(createData))
      }
    }

    const handleConfirm = (receiverName) => {
      dispatch(onConfirmTransfertOrder({ id: id, data: {name: receiverName} }))

    }

    const onClear = () => {
      setIsEdit(false)
      setSelectedDate(null)
      setSellectedDestination(null)
      setSellectedProduct(null)
      setTransfertOrderItems([])
    }

    const handleLoadUser=(role)=>{

      dispatch(getUserByRole())
    }

  return (
    <React.Fragment>
      {isLoading ?
          <GlobalLoader />
        :
          <>
            <div className="record-Purchase-contant pb-5">
                <div className="record-list py-4 px-4">
                    <h1>{ props.t("transfert_order")}</h1>
                    <div className="row  Purchase-order">
                        <h6>
                            <Link to="/warehouse/transfert-order">
                                <i className="fa-solid fa-chevron-left"></i> {isWatch ? props.t("stock_transfert") : isEdit ? props.t("edit_transfert_order") : props.t("new_stock_transfert")}
                            </Link>
                        </h6>
                    </div>

                    <div className="row py-3 Purchase-list">
                      {isEdit ?
                        <div className="col-lg-2 second-select pt-3">
                            <Label  htmlFor="supplier-field" className="form-label">
                                {props.t("transfert_order_no")}<span className='text-danger'>*</span>
                            </Label>
                            <h4 className='px-2'><b>{ transfertOrder && transfertOrder.orderRef }</b></h4>
                        </div>
                      : <></>
                      }

                        <div className="col-lg-3 second-select pt-3">
                            <Label  htmlFor="supplier-field" className="form-label">
                                {props.t("sector")}<span className='text-danger'>*</span>
                            </Label>
                            <Select
                                name='supplier'
                                id='supplier-field'
                                value={selectedDestination}
                                isMulti={false}
                                isClearable={false}
                                autoComplete="off"
                                onChange={(e) => {
                                  handleSelectDestination(e);
                                }}
                                options={transfertTo}
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                isDisabled = {isEdit || !isCreate || isValidate ? true : false}
                            />
                        </div>

                        <div className="col-lg-3 second-select pt-3">
                            <Label  htmlFor="supplier-field" className="form-label">
                                {props.t("transfert_order_data")}<span className='text-danger'>*</span>
                            </Label>
                            <Input
                                name="dob" id='dob-field' className="form-control" type="date"
                                value={selectedDate}
                                validate={{ required: { value: true } }}
                                max={getTodayDate()}
                                onChange={(e) => handleChangeDate(e.target.value)}
                                autoComplete="off"
                                disabled = {isEdit || !isCreate || isValidate? true : false}
                            />
                        </div>

                        <div className="col-lg-3 second-select pt-3">
                           {isEdit || isCreate ?<> <Label  htmlFor="product-field" className="form-label">
                                {props.t("product")}<span className='text-danger'>*</span>
                            </Label>
                            <Select
                                name='product'
                                id='product-field'
                                value=""
                                isMulti={false}
                                isClearable={false}
                                autoComplete="off"
                                onChange={(e) => {
                                  handleSelectProduct(e);
                                }}
                                onInputChange={(inputValue, { action }) => {
                                  if (action === 'input-change') {
                                    if (inputValue.length > 0) {
                                      handleSearchProduct(inputValue)
                                    } else {
                                      loadAllProduct()
                                    }
                                  }
                                }}
                                onMenuOpen={() => {
                                  loadAllProduct()
                                }}
                                options={productsOption}
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                isDisabled = { isEdit  ? false : isCreate?false: isValidate? true: false}
                                // isDisabled = {isEdit || !isCreate || isValidate ? true : false}
                            /> </>:isValidate ? <></>:<><p className='line-height-1 pb-0 mb-2'>Receiver Name</p>
                            <h5 className='border p-2 rounded-3'>{transfertOrder.receiverNmae}</h5>
                            </>

                           }

                        </div>
                         {
                          (isWatch ) && (
                             <div className="col-lg-3 second-select pt-4" style={{ textAlign: "right" }} >
                              <Button
                            color="primary"
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                                handlePrint()
                            }}
                        >
                          <i className="fa-solid fa-print"></i>
                          {props.t("print")}
                        </Button>
                          </div>
                          )
                         }

                    </div>

                    <div className="Purchase-all-list ">
                        <div className="table table-responsive">



                          {/* print View */}
                          <div ref={componentRef} className='d-none d-print-block'>

<div className='d-flex flex-column gap-1 p-3'>
<PrintHeader/>
<hr />
<div className='d-flex flex-column gap-1 '>
  <Row className='grid'>
  <Col>Transfer To: {transfertOrder.transferTo}</Col>
  <Col>order Date: {transfertOrder.orderDate}</Col>
  <Col>receiver Name: <b>{transfertOrder.receiverNmae}</b></Col>
</Row>
<Row className='grid'>
  <Col className='fw-bold'>order Ref: {transfertOrder.orderRef}</Col>
  <Col className='fw-bold'>Transfer Item count: {transfertOrder?.transferOrderItems?.length || 0}</Col>
  <Col className='fw-bold'>status: <b className='text-success'>{transfertOrder.status}</b></Col>
</Row>
</div>
<hr />
<div>
  <table className="table table-bordered">
    <thead>
      <tr>
        <th className='fw-bold'>Item</th>
        {/* <th className='fw-bold'>Quantity in Stock</th> */}
        <th className='fw-bold'>Quantity ordered</th>
        <th className='fw-bold'>unit price</th>
      </tr>
    </thead>
    <tbody>
      {
        transferOrderItems.map((item, index) => (
          <tr key={index}>
            <td>{item.name}</td>
            {/* <td>{item.quantityInStock}</td> */}
            <td>{item?.quantity}</td>
            <td>{item.unitPrice}</td>
          </tr>
        ))
      }
    </tbody>
  </table>
  <div className='text-center'>

  <em >we care we protect</em>
  </div>
</div>
</div>
                          </div>


                       <div className='d-flex justify-content-center'>
                           <div className="table-responsive col-12 col-lg-12">

                              <table className="table table-bordered "  >
                                <thead>
                                    <tr className="first-head">
                                        <th scope="col" style={{ width: "7%", textAlign: "center", padding:"17px" }}>{props.t("s_no")}</th>
                                        <th scope="col" style={{ width: "40%", padding:"17px" }}>{props.t("item")}</th>
                                        {!isWatch ? <th scope="col" style={{ width: "10%", textAlign: "center", padding:"17px" }}>{props.t("qtyInStock")}</th> : <></>}
                                        <th scope="col" style={{ width: "10%", textAlign: "center", padding:"17px" }}>{props.t("qtyToTransfert")}</th>
                                        {/* <th scope="col" style={{ width: "19%", padding: "17px" }}>{props.t("rate_fcfa")}</th>
                                        <th scope="col" style={{ width: "19%", padding:"17px" }}>{props.t("amount")}</th> */}
                                        {
                                          isWatch ?"": <th scope="col" style={{ width: "5%", textAlign: "center", padding: "17px" }}>{props.t("action")}</th>
                                        }
                                    </tr>
                                </thead>
                                <tbody>

                                  {transferOrderItems.map((row, index) => (
                                    <tr key={row.productId}>
                                      <TransfertRow row={row} index={index} isEdit={id ? true : false } isWatch={isWatch} isValidate= {isValidate} updateRow= {handleUpdateRow} deleteRow={onClickDelete}/>
                                    </tr>
                                  ))}
                                </tbody>
                            </table>
                           </div>

                       </div>



                            <div className="bttns">
                                <Link to="/warehouse/transfert-order" onClick={() => onClear()}>
                                  <button className="btn-secondary" style={{ padding: "6px 35px 6px 35px", fontSize: "18px", margin: "8px", textAlign: "center", borderRadius: "8px" }} type="button">{props.t("cancel")}</button>
                                </Link>
                                {!isWatch ?
                                  <button
                                    className="btn-two"
                                    onClick={() => saveOrder()}
                                    disabled={ selectedDate && (transferOrderItems?.length > 0) ? false : true }
                                  >
                                    {isValidate ? props.t("validate") : isEdit ? props.t("update") : isCreate? props.t("save"):""}
                                  </button>
                                  :
                                  <></>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <InputModal show={confirmModal} onConfirmClick={handleConfirm} onCloseClick={() =>setConfirmModal(false)} getReciever={handleLoadUser} recievers={recievers}/>
            <DeleteModal show={deleteModal} onDeleteClick={handleDelete} onCloseClick={() =>setDeleteModal(false)} />
          </>
      }
    </React.Fragment>
  )
}


const InputModal = (props) => {
  const [receiverName, setReceiverName] = useState('');
  const [selectedReceiver, setSelectedReceiver] = useState(null);

  const recievers = useMemo(() => {
    if (props.recievers && props.recievers.length > 0) {
      return props.recievers.map((receiver) => ({
        value: receiver.id,
        label: receiver.fullName,
      }));
    }
    return [];
  }, [props.recievers]);

  const handleSelectReceiver = (receiver) => {
    setSelectedReceiver(receiver);
    setReceiverName(receiver.label);
  };

  const handleCloseModal = () => {
    props.onCloseClick();
    setReceiverName('');
    setSelectedReceiver(null);
  };
  return (
    <Modal isOpen={props.show} toggle={handleCloseModal} backdrop={'static'} centered={true}>
      <ModalBody>
        <h4>Receivers Name</h4>
      <div>
      <Select
      options={recievers}
      value={selectedReceiver}
      onChange={handleSelectReceiver}
      placeholder="Select a receiver"
      />
      </div>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={props.onCloseClick}>Close</button>
          <button
            className="btn btn-primary"
            onClick={() => props.onConfirmClick(receiverName)}
            disabled={!receiverName}
          >
            Confirm
          </button>
        </ModalFooter>
      </ModalBody>
    </Modal>
  );
};

export default withRouter(withTranslation()(NewTransfertOrder))
